
<nav class="navbar" >
	<ul class="main-routes">
		<li class="route-link"
			*rxFor="let route of routes$;"
			(mouseenter)="route.children && route.submenu$?.set(true)"
  			(mouseleave)="route.children && route.submenu$?.set(false)"
		>
			<lib-button [route]=route></lib-button>

			<ul class="sub-routes" 
				*rxIf="route.children"
				[@submenuState]="route.submenu$?.() ? 'open' : 'closed'"
			>
				<li class="route-link" 
					*rxFor="let child of route.children" 
				>
					<lib-button [route]=child></lib-button>
				</li>				
			</ul>
		</li>
	</ul>
</nav>
